/* MEWRA product page behaviour — loaded once per page */
(function () {
  if (window.__mewraInit) return;
  window.__mewraInit = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const pad = (n) => String(n).padStart(2, '0');

  /* ---------- Countdowns: only real, merchant-set end dates. Hidden when empty/expired. ---------- */
  function initCountdowns() {
    $$('[data-mw-countdown]').forEach((el) => {
      const end = Date.parse(el.dataset.mwCountdown);
      const host = el.closest('[data-mw-countdown-host]') || el;
      if (!end || isNaN(end)) { host.hidden = true; return; }
      const tick = () => {
        const diff = end - Date.now();
        if (diff <= 0) { host.hidden = true; clearInterval(t); return; }
        const d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24,
              m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
        const set = (k, v) => { const n = el.querySelector(`[data-${k}]`); if (n) n.textContent = pad(v); };
        set('d', d); set('h', h); set('m', m); set('s', s);
      };
      tick(); const t = setInterval(tick, 1000);
    });
  }

  /* ---------- "Ships by" date: today + N business days (set this to your real handling time) ---------- */
  function initShipDates() {
    $$('[data-mw-shipdate]').forEach((el) => {
      let days = parseInt(el.dataset.mwShipdate, 10) || 1;
      const d = new Date();
      while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
      el.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery() {
    $$('[data-mw-gallery]').forEach((g) => {
      const track = $('.mw-gallery__main', g);
      const thumbs = $$('.mw-gallery__thumb', g);
      const slides = $$('.mw-gallery__slide', g);
      if (!track || !slides.length) return;
      const go = (i) => {
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      };
      const current = () => Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
      $('.mw-gallery__arrow--prev', g)?.addEventListener('click', () => go(current() - 1));
      $('.mw-gallery__arrow--next', g)?.addEventListener('click', () => go(current() + 1));
      track.addEventListener('scroll', () => {
        const i = current();
        thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
        thumbs[i]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }, { passive: true });
      // jump to variant image
      document.addEventListener('mw:variant', (e) => {
        const id = e.detail?.mediaId; if (!id) return;
        const idx = slides.findIndex((s) => s.dataset.mediaId === String(id));
        if (idx > -1) go(idx);
      });
    });
  }

  /* ---------- Generic scroll-carousels with progress dashes ---------- */
  function initCarousels() {
    $$('[data-mw-carousel]').forEach((wrap) => {
      const track = $('[data-mw-track]', wrap);
      const bars = $('.mw-progress', wrap);
      if (!track || !bars) return;
      const items = Array.from(track.children);
      const pages = Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth - 0.05));
      bars.innerHTML = '';
      if (pages < 2) return;
      for (let i = 0; i < pages; i++) {
        const b = document.createElement('span');
        b.addEventListener('click', () => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }));
        bars.appendChild(b);
      }
      const update = () => {
        const p = Math.round(track.scrollLeft / (track.scrollWidth - track.clientWidth || 1) * (pages - 1));
        $$('span', bars).forEach((b, i) => b.classList.toggle('is-active', i === p));
      };
      track.addEventListener('scroll', update, { passive: true }); update();
      if (wrap.dataset.mwAutoplay) {
        let paused = false;
        track.addEventListener('pointerenter', () => paused = true);
        track.addEventListener('pointerleave', () => paused = false);
        setInterval(() => {
          if (paused || document.hidden) return;
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
          track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + (items[0]?.offsetWidth || 300) + 14, behavior: 'smooth' });
        }, parseInt(wrap.dataset.mwAutoplay, 10) * 1000);
      }
    });
  }

  /* ---------- UGC videos: tap to play with sound ---------- */
  function initUgc() {
    $$('.mw-ugc__item').forEach((item) => {
      const v = $('video', item); if (!v) return;
      v.removeAttribute('controls');
      item.addEventListener('click', () => {
        $$('.mw-ugc__item video').forEach((o) => { if (o !== v) { o.pause(); o.closest('.mw-ugc__item').classList.remove('is-playing'); } });
        if (v.paused) { v.muted = false; v.play(); item.classList.add('is-playing'); }
        else { v.pause(); item.classList.remove('is-playing'); }
      });
    });
  }

  /* ---------- Product form ---------- */
  function initForms() {
    $$('[data-mw-product]').forEach((root) => {
      const form = $('form.mw-form', root);
      if (!form) return;
      const btn = $('[data-mw-submit]', form);
      const err = $('.mw-error', form);
      const idInput = $('[name="id"]', form);
      const after = root.dataset.mwAfter || 'cart';
      const variants = JSON.parse($('[data-mw-variants]', root)?.textContent || '[]');

      // variant changes → update prices / button / image
      const select = $('[data-mw-variant-select]', form);
      select?.addEventListener('change', () => {
        const v = variants.find((x) => String(x.id) === select.value); if (!v) return;
        $$('[data-mw-price]').forEach((n) => n.textContent = v.price_f);
        $$('[data-mw-compare]').forEach((n) => { n.textContent = v.compare_f || ''; n.hidden = !v.compare_f; });
        btn.disabled = !v.available;
        btn.querySelector('[data-mw-btn-text]').textContent = v.available ? btn.dataset.label : btn.dataset.soldout;
        document.dispatchEvent(new CustomEvent('mw:variant', { detail: { mediaId: v.media_id } }));
      });

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (btn.disabled) return;
        err.textContent = '';
        const label = btn.querySelector('[data-mw-btn-text]');
        const original = label.textContent;
        btn.disabled = true; label.textContent = btn.dataset.adding || 'Adding…';

        const plan = $('[name="selling_plan"]:checked', form) || $('select[name="selling_plan"]', form);
        const main = { id: Number(idInput.value), quantity: 1 };
        if (plan && plan.value) main.selling_plan = Number(plan.value);
        const items = [main];
        $$('[data-mw-gift-variant]', root).forEach((g) => {
          const id = Number(g.dataset.mwGiftVariant); if (id) items.push({ id, quantity: 1 });
        });

        try {
          const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          window.location.href = after === 'checkout' ? '/checkout' : '/cart';
        } catch (ex) {
          err.textContent = ex.message;
          btn.disabled = false; label.textContent = original;
        }
      });
    });

    // Every secondary CTA on the page ([data-mw-cta]) scrolls to the offer or adds directly
    document.addEventListener('click', (e) => {
      const cta = e.target.closest('[data-mw-cta]'); if (!cta) return;
      const root = $('[data-mw-product]'); if (!root) return;
      e.preventDefault();
      const form = $('form.mw-form', root);
      const mode = cta.dataset.mwCta || root.dataset.mwCta;
      if (mode === 'add' && form) form.requestSubmit();
      else $('#mw-buy')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------- Sticky add-to-cart ---------- */
  function initSticky() {
    const bar = $('[data-mw-sticky]'); const target = $('#mw-buy');
    if (!bar || !target) return;
    let pastTarget = false;
    new IntersectionObserver(([en]) => {
      pastTarget = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', pastTarget);
    }).observe(target);
  }

  const run = () => { initCountdowns(); initShipDates(); initGallery(); initCarousels(); initUgc(); initForms(); initSticky(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  // Re-run lightweight pieces when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', () => { initCountdowns(); initShipDates(); initCarousels(); });
})();
